import { v4 as uuidv4 } from "uuid";

import Fminor from './assets/Chords/Fminor.png';
import Amajor from './assets/Chords/Amajor.png';
import Eminor from './assets/Chords/Eminor.png';
import Emajor from './assets/Chords/Emajor.png';
import Cminor from './assets/Chords/Cminor.png';
import Dmajor from './assets/Chords/Dmajor.png';

import Perfect from './assets/Songs/Perfect.mp3';
import graph from './ML/data.json';


export default function ChillHop(time) {

	// LINK CHORDS TO THE CHORD DIAGRAMS
	const chordType = {
		'Ab:maj': Amajor,
		'F:min': Fminor,
		'Db:maj': Dmajor,
		'Eb:maj': Emajor,
		'Eb:min': Eminor,
		'N' : Amajor,
		'C:min': Cminor, //temporary until i find the correct chord diagram
	}

	let currentChord = ""
	let nextChord = ""
	// let pastChord = ""
	for (let n=0; n<MLdata.length; n++) {
		if (MLdata[n][0] <= time) {
			currentChord = MLdata[n][2]
			nextChord = MLdata[n+1][2]
			// pastChord = MLdata[n-1][2]
		};
	}
	// console.log(MLmodel)
	

	return [	
		{
			name: "Perfect",
			cover: "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
			image: chordType[currentChord],
			imageN: chordType[nextChord],
			artist: "Ed Sheeran",
			audio: Perfect,
			color: ["#205950", "#2ab3bf"],
			id: uuidv4(),
			active: true,
		},
		// {
		// 	name: "Daylight",
		// 	cover:
		// 		"https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
		// 	artist: "Aiguille",
		// 	audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
		// 	color: ["#EF8EA9", "#ab417f"],
		// 	id: uuidv4(),
		// 	active: false,
		// },
		
	];
	
}

// function strReplace(){
// 	var myStr = {graph};
// 	var newStr = myStr.replace('(', '[').replace('),','],\n');
	
// 	// Insert modified string in paragraph
// 	document.getElementById("myText").innerHTML = newStr;
// 	return [
// 		newStr
// 	]
// }

const MLmodel = {graph};


const MLdata = [
[0.0, 7.476825396825397, 'Ab:maj'],
[7.476825396825397, 11.42421768707483, 'F:min'],
[11.42421768707483, 15.232290249433106, 'Db:maj'],
[15.232290249433106, 18.854603174603174, 'Eb:maj'],
[18.854603174603174, 22.6162358276644, 'Ab:maj'],
[22.6162358276644, 26.656507936507936, 'F:min'],
[26.656507936507936, 29.72154195011338, 'Db:maj'],
[29.72154195011338, 30.696780045351474, 'N'],
[30.696780045351474, 33.94757369614513, 'Eb:maj'],
[33.94757369614513, 37.8485260770975, 'Ab:maj'],
[37.8485260770975, 41.61015873015873, 'F:min'],
[41.61015873015873, 45.55755102040816, 'Db:maj'],
[45.55755102040816, 47.55446712018141, 'Ab:maj'],
[47.55446712018141, 49.13342403628118, 'Eb:maj'],
[49.13342403628118, 53.080816326530616, 'Ab:maj'],
[53.080816326530616, 56.70312925170068, 'F:min'],
[56.70312925170068, 60.46476190476191, 'Db:maj'],
[60.46476190476191, 61.11492063492064, 'Eb:min'],
[61.11492063492064, 63.25115646258504, 'Eb:maj'],
[63.25115646258504, 64.27283446712018, 'C:min'],
[64.27283446712018, 66.26975056689342, 'F:min'],
[66.26975056689342, 68.31310657596372, 'Db:maj'],
[68.31310657596372, 70.12426303854875, 'Ab:maj'],
[70.12426303854875, 71.3317006802721, 'Eb:maj'],
[71.3317006802721, 73.79301587301588, 'F:min'],
[73.79301587301588, 75.88281179138322, 'Db:maj'],
[75.88281179138322, 77.69396825396825, 'Ab:maj'],
[77.69396825396825, 79.55156462585035, 'Eb:maj'],
[79.55156462585035, 81.40916099773243, 'F:min'],
[81.40916099773243, 83.22031746031746, 'Db:maj'],
[83.22031746031746, 85.35655328798187, 'Ab:maj'],
[85.35655328798187, 86.74975056689343, 'Eb:maj'],
[86.74975056689343, 87.12126984126985, 'Db:maj'],
[87.12126984126985, 89.16462585034014, 'F:min'],
[89.16462585034014, 90.97578231292518, 'Db:maj'],
[90.97578231292518, 93.01913832199547, 'Ab:maj'],
[93.01913832199547, 94.55165532879819, 'Eb:maj'],
[94.55165532879819, 95.71265306122449, 'Ab:maj'],
[95.71265306122449, 96.54857142857144, 'Eb:maj'],
[96.54857142857144, 98.40616780045352, 'F:min'],
[98.40616780045352, 100.40308390022676, 'Db:maj'],
[100.40308390022676, 101.37832199546486, 'Eb:maj'],
[101.37832199546486, 102.2142403628118, 'C:min'],
[102.2142403628118, 106.06875283446712, 'Ab:maj'],
[106.06875283446712, 109.96970521541951, 'F:min'],
[109.96970521541951, 113.54557823129252, 'Db:maj'],
[113.54557823129252, 117.3536507936508, 'Eb:maj'],
[117.3536507936508, 121.25460317460318, 'Ab:maj'],
[121.25460317460318, 124.83047619047619, 'F:min'],
[124.83047619047619, 128.77786848072563, 'Db:maj'],
[128.77786848072563, 132.53950113378684, 'Eb:maj'],
[132.53950113378684, 136.71909297052156, 'Ab:maj'],
[136.71909297052156, 140.20208616780045, 'F:min'],
[140.20208616780045, 143.6386394557823, 'Db:maj'],
[143.6386394557823, 145.96063492063493, 'Ab:maj'],
[145.96063492063493, 147.77179138321995, 'Eb:maj'],
[147.77179138321995, 151.4405442176871, 'Ab:maj'],
[151.4405442176871, 154.55201814058958, 'F:min'],
[154.55201814058958, 155.34149659863945, 'Ab:maj'],
[155.34149659863945, 159.1960090702948, 'Db:maj'],
[159.1960090702948, 162.53968253968253, 'Eb:maj'],
[162.53968253968253, 164.86167800453515, 'F:min'],
[164.86167800453515, 166.44063492063492, 'Db:maj'],
[166.44063492063492, 168.66975056689344, 'Ab:maj'],
[168.66975056689344, 170.38802721088436, 'Eb:maj'],
[170.38802721088436, 172.3849433106576, 'F:min'],
[172.3849433106576, 174.4282993197279, 'Db:maj'],
[174.4282993197279, 176.23945578231292, 'Ab:maj'],
[176.23945578231292, 177.6326530612245, 'Eb:maj'],
[177.6326530612245, 178.3292517006803, 'N'],
[178.3292517006803, 180.00108843537416, 'F:min'],
[180.00108843537416, 181.9980045351474, 'Db:maj'],
[181.9980045351474, 183.80916099773242, 'Ab:maj'],
[183.80916099773242, 185.43455782312927, 'Eb:maj'],
[185.43455782312927, 187.57079365079366, 'F:min'],
[187.57079365079366, 189.5677097505669, 'Db:maj'],
[189.5677097505669, 191.56462585034015, 'Ab:maj'],
[191.56462585034015, 192.49342403628117, 'Eb:maj'],
[192.49342403628117, 197.09097505668936, 'Ab:maj'],
[197.09097505668936, 200.80616780045352, 'F:min'],
[200.80616780045352, 204.75356009070296, 'Db:maj'],
[204.75356009070296, 208.05079365079365, 'Eb:maj'],
[208.05079365079365, 210.37278911564627, 'F:min'],
[210.37278911564627, 212.32326530612247, 'Db:maj'],
[212.32326530612247, 213.99510204081633, 'Ab:maj'],
[213.99510204081633, 215.80625850340135, 'Eb:maj'],
[215.80625850340135, 217.84961451247165, 'F:min'],
[217.84961451247165, 219.93941043083902, 'Db:maj'],
[219.93941043083902, 221.6112471655329, 'Ab:maj'],
[221.6112471655329, 223.4224036281179, 'Eb:maj'],
[223.4224036281179, 225.41931972789115, 'F:min'],
[225.41931972789115, 227.4162358276644, 'Db:maj'],
[227.4162358276644, 229.41315192743764, 'Ab:maj'],
[229.41315192743764, 231.17786848072564, 'Eb:maj'],
[231.17786848072564, 232.9425850340136, 'F:min'],
[232.9425850340136, 235.03238095238095, 'Db:maj'],
[235.03238095238095, 236.9364172335601, 'Ab:maj'],
[236.9364172335601, 238.93333333333334, 'Eb:maj'],
[238.93333333333334, 243.15936507936507, 'Db:maj'],
[243.15936507936507, 243.7166439909297, 'Eb:maj'],
[243.7166439909297, 246.17795918367347, 'N'],
[246.17795918367347, 247.29251700680274, 'Ab:maj'],
[247.29251700680274, 248.1748752834467, 'Eb:maj'],
[248.1748752834467, 249.66095238095238, 'F:min'],
[249.66095238095238, 250.0324716553288, 'Eb:maj'],
[250.0324716553288, 251.93650793650795, 'Db:maj'],
[251.93650793650795, 253.88698412698415, 'Eb:maj'],
[253.88698412698415, 260.1099319727891, 'Ab:maj'],
[260.1099319727891, 263.54648526077096, 'N'],
]

